var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSquare = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 136,
  height: 40,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "currentColor",
  clipPath: "url(#square_svg__a)",
  filter: "url(#square_svg__b)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M9.347 0h21.306a5.347 5.347 0 0 1 5.349 5.347v21.304A5.35 5.35 0 0 1 30.652 32H9.348A5.35 5.35 0 0 1 4 26.651V5.347A5.347 5.347 0 0 1 9.347 0M28.5 26.183c.932 0 1.687-.756 1.687-1.688l-.005-16.988c0-.932-.755-1.688-1.687-1.688H11.508a1.69 1.69 0 0 0-1.687 1.69v16.986c0 .932.755 1.688 1.687 1.688z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.605 20.339a.97.97 0 0 1-.96-.97v-6.78a.97.97 0 0 1 .968-.974h6.791a.97.97 0 0 1 .969.973v6.78a.97.97 0 0 1-.969.974zM52.285 14.574c-.99-.27-1.928-.525-2.656-.85-1.348-.602-1.975-1.437-1.975-2.626 0-2.248 2.173-3.26 4.337-3.26 2.058 0 3.854.85 5.06 2.394l.082.105 1.74-1.36-.084-.106c-1.604-2.04-3.98-3.158-6.692-3.158-1.806 0-3.46.488-4.658 1.375-1.347.985-2.058 2.415-2.058 4.122 0 3.967 3.735 4.934 6.738 5.712 3.038.8 4.9 1.41 4.9 3.726 0 2.28-1.845 3.754-4.698 3.754-1.412 0-4.025-.374-5.667-2.883l-.076-.118-1.83 1.324.072.107c1.553 2.35 4.233 3.7 7.36 3.7 4.25 0 7.107-2.399 7.107-5.967 0-4.083-3.884-5.14-7.002-5.991"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M73.148 13.75v-2.148h2.045v20.395h-2.045v-7.968c-1.167 1.6-2.918 2.477-4.977 2.477-3.888 0-6.605-3.113-6.605-7.608s2.723-7.632 6.605-7.632c2.045 0 3.796.88 4.977 2.484m-9.427 5.123c0 4.16 2.383 5.644 4.614 5.644l.005.001c2.92 0 4.808-2.236 4.808-5.645 0-3.41-1.89-5.614-4.813-5.614-3.401 0-4.614 2.9-4.614 5.614",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M88.711 11.602v8.05c0 2.819-1.93 4.865-4.588 4.865-2.207 0-3.282-1.31-3.282-4.004v-8.91h-2.044v9.327c0 3.494 1.898 5.579 5.078 5.579 1.981 0 3.683-.84 4.838-2.376v2.043h2.044V11.602z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M94.608 13.133c1.507-1.184 3.554-1.863 5.611-1.863 3.249 0 5.189 1.616 5.182 4.327V26.18h-2.046v-1.617c-1.032 1.294-2.526 1.949-4.448 1.949-3.132 0-5.078-1.713-5.078-4.467 0-3.582 3.375-4.144 4.813-4.383q.353-.058.718-.113l.01-.002c1.964-.302 3.991-.614 3.991-2.28 0-1.887-2.448-2.033-3.198-2.033-1.324 0-3.195.393-4.467 1.495l-.116.101-1.068-1.62zm1.355 8.797c0 2.335 2.199 2.588 3.144 2.588 2.056 0 4.257-1.096 4.253-4.176v-2.109c-.998.63-2.417.876-3.683 1.096l-.022.004-.635.113c-2.027.376-3.057.86-3.057 2.484",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M117.248 11.877c-.486-.346-1.252-.553-2.05-.553a5.22 5.22 0 0 0-4.144 2.135v-1.863h-2.044V26.17h2.044v-7.794c0-3.456 1.943-5.004 3.866-5.004a3.8 3.8 0 0 1 1.632.346l.138.073.648-1.854z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M117.847 18.929c0-4.509 2.811-7.659 6.831-7.659 3.872 0 6.578 2.796 6.571 6.807q-.003.522-.058 1.043l-.012.12H120c.051 3.209 1.983 5.278 4.947 5.278 1.698 0 3.17-.69 4.143-1.947l.089-.115 1.481 1.32-.082.1c-.985 1.2-2.779 2.631-5.745 2.631-4.176 0-6.986-3.045-6.986-7.578m6.775-5.696c-2.498 0-4.269 1.644-4.546 4.204h9.011c-.177-2.059-1.434-4.204-4.465-4.204",
  clipRule: "evenodd"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "square_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M4 0h128v32H4z"
})), /*#__PURE__*/React.createElement("filter", {
  id: "square_svg__b",
  width: 136,
  height: 40,
  x: 0,
  y: 0,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 4
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_587_2737"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_587_2737",
  result: "shape"
})))));
export default SvgSquare;